(function ($) {

    var delayTimer;
    var kindergardens = { result: [], totalMatching: 0 };
    var map;
    var markers;

    var source = $("#entity-template").html();
    var template = Handlebars.compile(source);
    var types = [];
    var ownertypes = [];
    var districts = [];
    var query = "";

    // Use received data to bind to view
    function kindergardenShowResult(data) {
        kindergardens.Items = data.Items;

        if (markers != null)
            map.removeLayer(markers);

        markers = L.markerClusterGroup();
        markers.clearLayers();

        const markerIcon = L.icon({
            // specify the path here
            iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png",
            shadowUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-shadow.png",
            // Uten disse setter Leaflet ingen margin, og ikonets øverste venstre hjørne
            // havner på koordinatet i stedet for nålespissen. Samme mål som standardikonet
            // map.js bruker på entitetssidene.
            iconSize: [25, 41],
            iconAnchor: [12, 41],
            popupAnchor: [1, -34],
            shadowSize: [41, 41]
        });

        $(kindergardens.Items).each(function (index, item) {
            // Exclude markers with coordinates at 0, 0
            if (item.Latitude !== 0 || item.Longitude !== 0) {
                // Uten koordinater ville markøren havnet på 0,0, utenfor Afrika
                if (!item.Latitude || !item.Longitude) {
                    return;
                }

                // create the marker
                var marker = L.marker([item.Latitude, item.Longitude], { icon: markerIcon });
                marker.bindPopup('' +
                    '<strong><a href="' + item.Url + '">' + item.Name + '</a></strong><br />' +
                    '<strong>Antall barn:</strong> ' + item.Children + '<br />' +
                    '<strong>Eierform:</strong> ' + item.OwnerType + '<br />' +
                    '<strong>Alder:</strong> ' + item.Age + '<br />' +
                    '<a href="https://maps.google.com/?daddr=' + item.Latitude + ',' + item.Longitude + '" target="_new" class="external">Se veibeskrivelse</a>'
                );
                markers.addLayer(marker);
            }
        });

        map.addLayer(markers);
        // Treff uten koordinater gir ingen markør, og tomme bounds får Leaflet til å kaste.
        if (markers.getLayers().length) {
            map.fitBounds(markers.getBounds(), { padding: [20, 20] });
        }

        kindergardens.TotalMatching = data.TotalMatching;
        var html = template(kindergardens);
        $("#entities-result").html(html);
    }
    // Search for string and handle received data
    function kindergardenSearch(query, filters) {
        clearTimeout(delayTimer);
        delayTimer = setTimeout(function () {

            // Update url with query
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?q=' + query;

                // Add districts selection
                if (filters.districts.length)
                    newurl = newurl + "&d=" + filters.districts;

                // Add types selection
                if (filters.types.length)
                    newurl = newurl + "&t=" + filters.types;

                // Add ownertypes selection
                if (filters.ownertypes.length)
                    newurl = newurl + "&o=" + filters.ownertypes;

                window.history.pushState({ path: newurl }, '', newurl);
            }

            $.getJSON("/api/kindergarden/search", { query: query, districts: filters.districts, types: filters.types, ownertypes: filters.ownertypes }, kindergardenShowResult);
        }, 250);
    }

    // Handle search input text input
    var entitySearchInputTimer;
    $('#search-entity-form .entity-search-input').on('input', function () {
        query = $(this).val();

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }
        kindergardenSearch(query, filters);
    });

    // Trigger input event if value is present
    if ($('#search-entity-form .entity-search-input').val() !== '') {
        $("#search-entity-form .entity-search-input").trigger("input");
    }

    // Handle button search
    $('#search-entity-form input[type=submit]').click(function (e) {
        var val = $(this).siblings(".entity-search-input").val();
        query = val;

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }
        kindergardenSearch(query, filters);
    });

    map = initializeMap("entities-map", 58.97, 5.74, 12);

    // Search for blank on start
    $(document).ready(function () {

        $('.filter-district input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                districts.push($(this).val());
            } else {
                var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    districts.splice(index, 1);
                }
            }
        })

        $('.filter-ownertype input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                ownertypes.push($(this).val());
            } else {
                var index = ownertypes.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    ownertypes.splice(index, 1);
                }
            }
        })

        $('.filter-type input[type=checkbox]').each(function () {
            if ($(this).is(":checked")) {
                types.push($(this).val());
            } else {
                var index = types.indexOf($(this).val());    // <-- Not supported in <IE9
                if (index !== -1) {
                    types.splice(index, 1);
                }
            }
        })

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }
        kindergardenSearch(query, filters);
    });

    $(".filter-district input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            districts.push($(this).val());
        } else {
            var index = districts.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                districts.splice(index, 1);
            }
        }

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }

        kindergardenSearch(query, filters);
    });


    $(".filter-ownertype input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            ownertypes.push($(this).val());
        } else {
            var index = ownertypes.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                ownertypes.splice(index, 1);
            }
        }

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }

        kindergardenSearch(query, filters);
    });

    $(".filter-type input[type=checkbox]").change(function () {

        if ($(this).is(":checked")) {
            types.push($(this).val());
        } else {
            var index = types.indexOf($(this).val());    // <-- Not supported in <IE9
            if (index !== -1) {
                types.splice(index, 1);
            }
        }

        var filters = {
            districts: districts.join(),
            types: types.join(),
            ownertypes: ownertypes.join()
        }

        kindergardenSearch(query, filters);
    });
})(jQuery);